import { AvtGateway, HttpRequest } from '../../../kernel/avt.gateway'
import { AddItemsRepository } from '../domain/add-items.repository'
import { BodyToAddItems, AddItemsResponse } from '../domain/entities'

export const addItemsRepository: AddItemsRepository = {
  addItems: async (body: BodyToAddItems) => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/nebula/items/operations/add-items`,
      body: {
        job_id: body.jobId,
        origin: body.origin,
        currency_code: body.currency,
        items: [
          {
            ...body.items
          }
        ]
      }
    }
    const result = await AvtGateway.executePostRequest(request)

    const response: AddItemsResponse = {
      jobId: result['job_id'],
      itemsIds: result['items_ids']
    }

    return response
  }
}
